import { compareConstants } from '../_constants/compare.constants';

const initialState = {
  compareFunds: null,
  tempCompareFunds: [],
  isFetching: false,
  isOpenCompareModal: false,
  errorMessage: undefined,
  searchIndex: 0,
  statusReturn: false,
  statusDrawdown: false,
  statusProportion: false,
  fundList: [],
  graph: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  funds: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  fundByPeriod: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  navFunds: {
    isFetching: false,
    data: [],
    errorMessage: null
  }
};

const compareReducer = (state = initialState, action) => {
  switch (action.type) {
    case compareConstants.TOGGLED_COMPARE_MODAL:
			return {
				...state,
				isOpenCompareModal: !state.isOpenCompareModal
			};
    case compareConstants.ADD_FUNDIDS_TO_COMPARE_FUNDS:
      return {
        ...state,
        fundList: action.payload.map(fund => ({ ...fund, isShowGraph: fund.isShowGraph ?? true }))
      };
    case compareConstants.UPDATE_FUNDIDS_TO_COMPARE_FUNDS:
      const { type, fundId } = action.payload
      if (type === 'DELETE') {
        return {
          ...state,
          fundList: state.fundList.filter(fund => fund.fundId !== fundId)
        }
      }
      if (type === 'UPDATE') {
        return {
          ...state,
          fundList: state.fundList.map(fund => fund.fundId === fundId ?
            { ...fund, isShowGraph: !fund.isShowGraph } : fund)
        }
      }
      return
    case compareConstants.UPDATE_TEMPORARY_COMPARE_FUNDS: {
      let { fundId } = action.payload;
      let isAddedFundId = state.tempCompareFunds.some(compareFund => compareFund.fundId.includes(fundId));

      if (fundId && !isAddedFundId) {
        return {
          ...state,
          tempCompareFunds: [
            ...state.tempCompareFunds,
            action.payload
          ]
        };
      }

      return state;
    }
    case compareConstants.REMOVED_TEMPORARY_COMPARE_FUNDS: {
      let { fundId } = action.payload;

      return {
        ...state,
        tempCompareFunds: state.tempCompareFunds.filter(fund => fund.fundId !== fundId)
      };
    }
    case compareConstants.RESET_TEMPORARY_COMPARE_FUNDS:
      return {
        ...state,
        tempCompareFunds: state.fundList
      };
    case compareConstants.FETCH_COMPARE_START:
      return {
        ...state,
        funds: {
          ...state.funds,
          isFetching: true
        }
      };
    case compareConstants.FETCH_COMPARE_SUCCESS:
      return {
        ...state,
        compareFunds: action.payload,
        funds: {
          ...state.funds,
          isFetching: false,
          data: action.payload,
          errorMessage: null
        }
      };
    case compareConstants.FETCH_COMPARE_FAILURE:
      return {
        ...state,
        funds: {
          ...state.funds,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    // case compareConstants.CLEAR_FUND_COMPARE:
    //   return {
    //     ...state,
    //     compareFunds: null,
    //     funds: {
    //       ...state.funds,
    //       fundIds: [],
    //       data: []
    //     }
    //   };
    case compareConstants.CLEAR_FUND_COMPARE:
      return {
        ...state,
        compareFunds: null,
        funds: {
          ...state.funds,
          fundIds: [],
          data: []
        }
      };
    case compareConstants.TOGGLE_RETURN:
      return {
        ...state,
        statusReturn: !state.statusReturn
      };
    case compareConstants.TOGGLE_DRAWDOWN:
      return {
        ...state,
        statusDrawdown: !state.statusDrawdown
      };
    case compareConstants.TOGGLE_PROPORTION:
      return {
        ...state,
        statusProportion: !state.statusProportion
      };
    case compareConstants.INSERT_SEARCH_INDEX:
      return {
        ...state,
        searchIndex: action.payload
      };
    case compareConstants.FETCH_GRAPH_COMPARE_FUNDS_START:
      return {
        ...state,
        graph: {
          ...state.graph,
          isFetching: true
        }
      };
    case compareConstants.FETCH_GRAPH_COMPARE_FUNDS_SUCCESS:
      return {
        ...state,
        graph: {
          ...state.graph,
          isFetching: false,
          data: action.payload,
          errorMessage: null
        }
      };
    case compareConstants.FETCH_GRAPH_COMPARE_FUNDS_FAILURE:
      return {
        ...state,
        graph: {
          ...state.graph,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    case compareConstants.FETCH_COMPARE_FUNDS_BY_PERIOD_START:
      return {
        ...state,
        fundByPeriod: {
          ...state.fundByPeriod,
          isFetching: true
        }
      };
    case compareConstants.FETCH_COMPARE_FUNDS_BY_PERIOD_SUCCESS:
      return {
        ...state,
        fundByPeriod: {
          ...state.fundByPeriod,
          isFetching: false,
          data: action.payload,
          errorMessage: null
        }
      };
    case compareConstants.FETCH_COMPARE_FUNDS_BY_PERIOD_FAILURE:
      return {
        ...state,
        fundByPeriod: {
          ...state.fundByPeriod,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    case compareConstants.FETCH_NAV_COMPARE_FUNDS_START:
      return {
        ...state,
        navFunds: {
          ...state.navFunds,
          isFetching: true
        }
      };
    case compareConstants.FETCH_NAV_COMPARE_FUNDS_SUCCESS:
      return {
        ...state,
        navFunds: {
          ...state.navFunds,
          isFetching: false,
          data: action.payload,
          errorMessage: null
        }
      };
    case compareConstants.FETCH_NAV_COMPARE_FUNDS_FAILURE:
      return {
        ...state,
        navFunds: {
          ...state.navFunds,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    default:
      return state;
  }
};

export default compareReducer;
